export default __webpack_public_path__ + "static/media/leanest_fees_possible.57710ac4.svg";